export default "__VITE_ASSET__oWiFO9tY__"